export const MOCK_DATA = false;

export const ORG_COLLECTION_NAME = 'organisations';
export const EMP_COLLECTION_NAME = 'organisations';

// magic number to change the layout for smaller devices (mobiles)
export const TIGHT_FIT_PARAM = 450;
export const TABLE_NAME_FIELD_WIDTH = 500;
export const TABLE_NAME_FIELD_TIGHT_FIT_WIDTH = 150;


// WEBPACK FOOTER //
// ./constants/System.js